/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { GetUsersModel } from '../entities/GetUsersModel'
import type { ToZod } from '@kubb/plugin-zod/utils'
import { domainUserRoleStringSchema } from './domain/userRoleStringSchema'
import { userStatusSchema } from './userStatusSchema'
import { z } from 'zod'

export const getUsersModelSchema = z.object({
  created_at: z.string(),
  email: z.string(),
  id: z.string(),
  name: z.string(),
  phone: z.number().int(),
  public_id: z.number().int(),
  role: z.lazy(() => domainUserRoleStringSchema),
  status: z.lazy(() => userStatusSchema),
}) as unknown as ToZod<GetUsersModel>